import { render, staticRenderFns } from "./list.vue?vue&type=template&id=88ed2b88&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/common.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./list.vue?vue&type=style&index=1&id=88ed2b88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ed2b88",
  null
  
)

export default component.exports